/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IImageGridData } from './image-grid.data';
import { IImageGridProps } from './image-grid.props.autogenerated';

export interface IImageGridViewProps extends IImageGridProps<IImageGridData> {}

/**
 *
 * ImageGrid component
 * @extends {React.PureComponent<IImageGridProps<IImageGridData>>}
 */
class ImageGrid extends React.PureComponent<IImageGridProps<IImageGridData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default ImageGrid;
